const esJSON = {
  'Templates request has failed': 'La solicitud de plantillas ha fallado', // /content/Templates/index.
  'Template Library': 'Biblioteca de plantillas', // /content/Templates/index.
  'Graphics request has failed': 'La solicitud de gráficos ha fallado', // /content/Graphics/index.
  'My graphics': 'Mis gráficos', // /content/Graphics/index.
  'Go to templates list': 'Ve a la lista de plantillas', // /content/Graphics/index.
  Copy: 'Copiar', // /content/Graphics/_component/Graphic.
  Edit: 'Editar', // /content/Graphics/_component/Graphic.
  Delete: 'Eliminar', // /content/Graphics/_component/Graphic.
  'View templates list': 'Ver lista de plantillas', // /content/Overview/Hero/index.
  'Preview image': 'Vista previa de la imagen', // /content/Editor/_component/EditorForm/EditorForm.
  'Guud Creative Studio': 'Guud Creative Studio', // /component/Logo/index.
  'Image editor': 'Editor de imágenes', // /component/EditImageModal/index.
  'Use this dialog window to edit a image':
    'Usa esta ventana de diálogo para editar una imagen', // /component/EditImageModal/index.
  Cancel: 'Cancelar', // /component/EditImageModal/index.
  'Save image': 'Guardar imagen', // /component/EditImageModal/index.
  Version: 'Versión', // /component/Logo/index.
  'Edit this image': 'Edita esta imagen', // /component/UploadImageField/index.
  'Remove this image': 'Elimina esta imagen', // /component/UploadImageField/index.
  'Choose a file or drag it here': 'Elige un archivo o arrástralo aquí', // /component/UploadImageField/index.
  'Editor form': 'Formulario del editor', // /component/Editor/Templates/TemplateResizer.
  'Graphic has been successfully': 'El gráfico se ha creado con éxito', // /layout/CreativeStudioLayout/EditorHeader/index.
  'Go to graphics selection': 'Ve a la selección de gráficos', // /layout/CreativeStudioLayout/EditorHeader/index.
  'Go to template selection': 'Ve a la selección de plantillas', // /layout/CreativeStudioLayout/EditorHeader/index.
  'Text is too long': 'El texto es demasiado largo', // /layout/CreativeStudioLayout/EditorHeader/index.
  Download: 'Descargar', // /layout/CreativeStudioLayout/EditorHeader/index.
  Save: 'Guardar', // /layout/CreativeStudioLayout/EditorHeader/index.
  'Language Switcher': 'Cambiador de idioma', // /layout/CreativeStudioLayout/Header/Buttons/LanguageSwitcher/index.
  Profile: 'Perfil', // /layout/CreativeStudioLayout/Header/Userbox/index.
  Inbox: 'Bandeja de entrada', // /layout/CreativeStudioLayout/Header/Userbox/index.
  Project: 'Proyecto', // /layout/CreativeStudioLayout/Header/Userbox/index.
  'Sign out': 'Cerrar sesión', // /layout/CreativeStudioLayout/Header/User
  'Sign in': 'Iniciar sesión', // /layout/CreativeStudioLayout/Header/Userbox/index.
  Workspaces: 'Espacios de trabajo', // /layout/CreativeStudioLayout/Sidebar/SidebarMenu/items.
  'Social Accounts': 'Cuentas sociales', // /layout/CreativeStudioLayout/Sidebar/SidebarMenu/items.
  'Everything you need to create beautiful designs that will engage your audience. Select a template to get started and make your own images for your business and social media.':
    'Selecciona una plantilla para comenzar y crea tus propias imágenes para tu negocio y redes sociales.', // /layout/Content/Overview/Hero/index.
  'Start creating designs that will impress':
    'Comienza a crear diseños sorprendentes', // /layout/Content/Overview/Hero/index.
  Editor: 'Editor', // /layout/Content/Overview/Sidebar/SidebarMenu/items.
  'Create images and videos in seconds': 'Crea imágenes y vídeos en segundos',
  'Start from a template': 'Elige una plantilla',
  'Template tags': 'Etiquetas para plantillas',
  'Select tags...': 'Selecciona etiquetas...',
  Search: 'Buscar',
  'No templates are available. Contact Guud.tv':
    'No hay plantillas disponibles. Contacta con Guud.tv',
  //Graphics view
  'Start creating amazing graphics': 'Empieza a crear gráficos increíbles',
  'Search by name': 'Buscar por nombre',
  //Settings view
  Settings: 'Configuración',
  Colors: 'Colores',
  "You don't have colors yet, start creating them":
    'Todavía no tienes colores, empieza a crearlos',
  'Create color': 'Crear color',
  'Add color': 'Añadir color',
  'Color name': 'Nombre color',
  'My logotypes': 'Mis logotipos',
  // Account / Payment view
  Trial: 'Plan de prueba'
};
export default esJSON;
